import { render } from "./MovieList.vue?vue&type=template&id=41601d6a&scoped=true"
import script from "./MovieList.vue?vue&type=script&lang=js"
export * from "./MovieList.vue?vue&type=script&lang=js"

import "./MovieList.vue?vue&type=style&index=0&id=41601d6a&scoped=true&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\vue-ghibli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41601d6a"]])

export default __exports__